import { downloadSteps, versionRows } from '@/mocks/home';

export default function AppDownloadSection() {
  return (
    <section id="app" className="scroll-mt-24 border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-[1fr_1.2fr]">
          <div className="relative order-2 overflow-hidden rounded-lg border border-background-200 lg:order-1">
            <div className="aspect-[4/5] w-full sm:aspect-[16/12] lg:aspect-[4/5]">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20smartphone%20floating%20over%20warm%20orange%20and%20cream%20studio%20background%2C%20abstract%20app%20interface%20cards%2C%20clean%20minimal%20product%20photography%2C%20soft%20shadow%2C%20no%20text&width=900&height=1120&seq=baoliao-app-01&orientation=portrait"
                alt="爆料网客户端界面示意"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute left-4 top-4 rounded-md bg-background-50/90 px-3 py-1.5 text-xs font-medium text-foreground-800 backdrop-blur">
              客户端 v6.2.1
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="text-xs font-medium uppercase tracking-[0.2em] text-primary-700">App Download</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">App 下载与安装步骤</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              客户端在弱网环境下比网页端更稳定。请按下面的四个步骤，从官方页面下载并完成安装，
              安装后留意版本号是否为最新。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {downloadSteps.map((step, index) => (
                <div key={step.title} className="rounded-lg border border-background-200 bg-background-100 p-5">
                  <div className="flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                      <i className={`${step.icon} text-lg`} aria-hidden="true" />
                    </span>
                    <span className="font-heading text-base font-semibold text-foreground-950">
                      {String(index + 1).padStart(2, '0')} {step.title}
                    </span>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 overflow-hidden rounded-lg border border-background-200">
          <table className="w-full border-collapse text-left text-sm">
            <thead>
              <tr className="bg-foreground-950 text-background-100">
                <th className="px-4 py-3 font-medium md:px-5">平台</th>
                <th className="px-4 py-3 font-medium md:px-5">版本</th>
                <th className="hidden px-4 py-3 font-medium sm:table-cell md:px-5">大小</th>
                <th className="hidden px-4 py-3 font-medium md:table-cell md:px-5">系统要求</th>
                <th className="px-4 py-3 font-medium md:px-5">获取方式</th>
              </tr>
            </thead>
            <tbody>
              {versionRows.map((row, index) => (
                <tr key={row.platform} className={index % 2 === 0 ? 'bg-background-50' : 'bg-background-100'}>
                  <td className="whitespace-nowrap px-4 py-3 font-medium text-foreground-950 md:px-5">{row.platform}</td>
                  <td className="whitespace-nowrap px-4 py-3 text-primary-700 md:px-5">{row.version}</td>
                  <td className="hidden whitespace-nowrap px-4 py-3 text-foreground-600 sm:table-cell md:px-5">{row.size}</td>
                  <td className="hidden whitespace-nowrap px-4 py-3 text-foreground-600 md:table-cell md:px-5">{row.requirement}</td>
                  <td className="whitespace-nowrap px-4 py-3 text-foreground-800 md:px-5">{row.channel}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}